




import { Component, Prop, Vue } from 'vue-property-decorator'
import LeituraDaAtualizacao from '@/components/novidades/LeituraDaAtualizacao.vue'

@Component({ components: { LeituraDaAtualizacao } })
export default class TelaDeLeituraDeNovidade extends Vue {
	@Prop({ type: String, required: true }) id!: string
}
